export function toTemporalZonedDateTime(
    date: Date | string | number,
    timezone?: string,
): Temporal.ZonedDateTime {
    const tz = timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (typeof date === "string") {
        const trimmed = date.trim();
        const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(trimmed);
        if (isDateOnly) {
            const plainDate = Temporal.PlainDate.from(trimmed);
            return plainDate.toZonedDateTime({
                timeZone: tz,
                plainTime: Temporal.PlainTime.from("00:00"),
            });
        }
    }

    const dateObj =
        typeof date === "string" || typeof date === "number"
            ? new Date(date)
            : date;
    const instant = Temporal.Instant.fromEpochMilliseconds(
        (dateObj as Date).getTime(),
    );
    return instant.toZonedDateTimeISO(tz);
}

export function toDate(zdt: Temporal.ZonedDateTime): Date {
    return new Date(zdt.toInstant().epochMilliseconds);
}

export function now(timezone?: string): Temporal.ZonedDateTime {
    return Temporal.Now.zonedDateTimeISO(
        timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
    );
}

export function today(timezone?: string): Temporal.PlainDate {
    return Temporal.Now.plainDateISO(
        timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
    );
}

export function parseISODate(
    isoString: string,
    timezone?: string,
): Temporal.ZonedDateTime {
    const instant = Temporal.Instant.from(isoString);
    return instant.toZonedDateTimeISO(
        timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
    );
}
